const thinBorder = (color = "CCCCCC") => ({
  top: { style: "thin", color: { rgb: color } },
  bottom: { style: "thin", color: { rgb: color } },
  left: { style: "thin", color: { rgb: color } },
  right: { style: "thin", color: { rgb: color } },
});

export const defaultHeaderStyle = {
  font: { bold: true, color: { rgb: "FFFFFF" }, size: 12 },
  fill: { fgColor: { rgb: "667eea" } },
  alignment: { horizontal: "center", vertical: "center" },
  border: thinBorder("000000"),
};

export const defaultDataStyle = {
  font: { size: 11 },
  alignment: { horizontal: "center", vertical: "center" },
  border: thinBorder("CCCCCC"),
};

export const defaultAlternateRowStyle = {
  font: { size: 11 },
  alignment: { horizontal: "center", vertical: "center" },
  fill: { fgColor: { rgb: "F8F9FA" } },
  border: thinBorder("CCCCCC"),
};

export function buildExcelConfig({ sheetName, widths, numericColumns = [], columnMap }) {
  return {
    sheetName,
    columnConfig: { widths, numericColumns, columnMap },
    headerStyle: defaultHeaderStyle,
    dataStyle: defaultDataStyle,
    alternateRowStyle: defaultAlternateRowStyle,
  };
}
